<tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode() }" [subtitle]="layoutSubtitle">
    <tec-progress [value]="progressService.getValue(progressConf)"></tec-progress>
    <ng-container content>
        @if (showIntro()) {
            <app-dynamic-form-intro />
        } @else if (showFormHelp()) {
            <app-dynamic-form-help />
        } @else if (currentStep) {
            <app-dynamic-form-step
                [step]="currentStep"
                [stepForm]="stepForm"
                [wide]="usesWideFieldsLayout()"
                [showBackActions]="canGoBack"
                [apiError]="apiError()"
                [stepTitle]="currentStepTitle"
                [stepDescription]="currentStepDescription"
                [resolveLocalizedText]="resolveText"
                [stepFieldOptions]="stepFieldOptions"
                [stepFieldSelectSearch]="stepFieldSelectSearch"
                [stepFieldSelectPlaceholder]="stepFieldSelectPlaceholder"
                [stepFieldSelectDisabled]="stepFieldSelectDisabled"
                [countryProvinceCascade]="countryProvinceCascade"
                [legalToggleOptions]="legalToggleOptions"
                [showValidationErrors]="showValidationErrors()"
                (legalToggleChange)="onLegalToggleChange($event)"
                (fileSelected)="onUploadFiles($event)"
            />
        }
    </ng-container>

    <ng-container actions>
        @if (showIntro()) {
            <tec-button
                size="lg"
                type="secondary"
                class="dynamic-form__back-button dynamic-form__back-button--sizer"
                icon="icon-chevron-left"
                iconPosition="left"
                [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                tabindex="-1"
                aria-hidden="true"
            />
            <tec-button
                size="lg"
                class="dynamic-form-intro__continue"
                [label]="'FORM.INTRO.CONTINUE' | translate"
                (clickEvent)="startForm()"
            />
        } @else if (showFormHelp()) {
            <tec-button
                size="lg"
                type="secondary"
                class="dynamic-form-help__change-device"
                [label]="'FORM.HELP.CHANGE_DEVICE' | translate"
                (clickEvent)="openScanFromHelp()"
            />
            <tec-button
                size="lg"
                class="dynamic-form-help__go-back"
                [label]="'FORM.HELP.GO_BACK' | translate"
                (clickEvent)="showFormHelp.set(false)"
            />
        } @else if (currentStep) {
            @if (!canGoBack) {
                <tec-button
                    size="lg"
                    type="secondary"
                    class="dynamic-form__back-button dynamic-form__back-button--sizer"
                    icon="icon-chevron-left"
                    iconPosition="left"
                    [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                    tabindex="-1"
                    aria-hidden="true"
                />
            }
            @if (canGoBack) {
                <tec-button
                    size="lg"
                    type="secondary"
                    class="dynamic-form__back-button"
                    icon="icon-chevron-left"
                    iconPosition="left"
                    [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                    [disabled]="submitting()"
                    (clickEvent)="goBack()"
                />
            }
            <tec-button
                size="lg"
                class="dynamic-form__primary-button"
                [label]="(isLastStep ? 'FORM.FINISH' : 'FORM.CONTINUE') | translate"
                [loading]="submitting()"
                [disabled]="submitting()"
                (clickEvent)="submitStep()"
            />
        }
    </ng-container>

    @if (navsHelp.length && !showIntro()) {
        <tec-nav-help [elements]="navsHelp" (clickEvent)="navHelpChange($event)" />
    }
</tec-pwcs-layout>

<app-modal-scan-qr
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
    titleKey="FORM.MODAL_SCAN.TITLE"
    descriptionKey="FORM.MODAL_SCAN.DESCRIPTION"
    descriptionWithRecordingKey="FORM.MODAL_SCAN.DESCRIPTION"
/>
